enum Zahlweise {
    MONATLICH = 'MONATLICH',
    VIERTELJAHRLICH = 'VIERTELJÄHRLICH',
    HALBJAHRLICH = 'HALBJÄHRLICH',
    JAHRLICH = 'JÄHRLICH',

    EINMALZAHLUNG = 'EINMALZAHLUNG',
    SAISONBEITRAG = 'SAISONBEITRAG'
}

export default Zahlweise;
